import axios from 'axios';
import { baseUrl } from './index';

export default axios.create({
  baseURL: `${baseUrl}`
});